import { render, staticRenderFns } from "./activity-multi.vue?vue&type=template&id=4ab09165&scoped=true"
import script from "./activity-multi.vue?vue&type=script&lang=js"
export * from "./activity-multi.vue?vue&type=script&lang=js"
import style0 from "./activity-multi.vue?vue&type=style&index=0&id=4ab09165&prod&scoped=scoped&lang=less"
import style1 from "./activity-multi.vue?vue&type=style&index=1&id=4ab09165&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab09165",
  null
  
)

export default component.exports